export default from './GlobalFooter.js';



// WEBPACK FOOTER //
// ./src/components/GlobalFooter/index.js